/* ============================================================
   KEPT — cart drawer
   Uses Shopify's cart AJAX endpoints. Add to cart is intercepted
   so the drawer opens in place instead of navigating away, and
   falls back to a normal form post if anything goes wrong — a
   broken script must never cost a sale.
   ============================================================ */
(function () {
  'use strict';
  if (window.__keptCartInit) return;
  window.__keptCartInit = true;

  var drawer, list, subtotal, totalEl, countEls, headCount, emptyEl, footEl;
  var ship, shipMsg, shipFill, shipIcon;
  var locale = document.documentElement.lang || 'da-DK';
  var currency = 'DKK';

  function money(cents) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function open() {
    if (!drawer) return;
    drawer.hidden = false;
    window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('kept-drawer-open');
    var close = drawer.querySelector('[data-kept-cart-close]');
    if (close && close.focus) close.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('kept-drawer-open');
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 320);
  }

  function setCount(n) {
    countEls.forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
    if (headCount) headCount.textContent = n > 0 ? '(' + n + ')' : '';
  }

  /* The threshold is authored in kroner; the cart works in minor units. */
  function renderShipping(total) {
    if (!ship) return;
    var threshold = parseFloat(ship.getAttribute('data-threshold')) * 100;
    if (!threshold || threshold <= 0) { ship.hidden = true; return; }

    ship.hidden = false;
    var remaining = threshold - total;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));

    if (remaining <= 0) {
      ship.classList.add('is-reached');
      shipMsg.textContent = ship.getAttribute('data-reached');
    } else {
      ship.classList.remove('is-reached');
      shipMsg.textContent = ship.getAttribute('data-progress').replace('[amount]', money(remaining));
    }

    shipFill.style.width = pct + '%';
    if (shipIcon) shipIcon.style.left = pct + '%';
  }

  function render(cart) {
    currency = cart.currency || currency;
    setCount(cart.item_count);
    renderShipping(cart.total_price);

    if (!cart.items.length) {
      list.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;

    list.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var img = item.image
        ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" width="70" height="88" loading="lazy">'
        : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="kept-cart__variant">' + esc(item.variant_title) + '</p>'
        : '';
      var was = item.original_line_price > item.line_price
        ? ' <s>' + money(item.original_line_price) + '</s>'
        : '';
      return '' +
        '<li class="kept-cart__item">' +
          '<div class="kept-cart__thumb">' + img + '</div>' +
          '<div class="kept-cart__info">' +
            '<p class="kept-cart__name">' + esc(item.product_title) + '</p>' +
            variant +
            '<p class="kept-cart__price">' + money(item.line_price) + was + '</p>' +
            '<div class="kept-cart__qty">' +
              '<button type="button" data-kept-line="' + line + '" data-kept-qty="' + (item.quantity - 1) + '" aria-label="Reducer antal">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-kept-line="' + line + '" data-kept-qty="' + (item.quantity + 1) + '" aria-label="Forøg antal">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="kept-cart__remove" data-kept-line="' + line + '" data-kept-qty="0" aria-label="Fjern">&times;</button>' +
        '</li>';
    }).join('');

    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (totalEl) totalEl.textContent = '· ' + money(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function change(line, quantity) {
    drawer.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      render(cart);
      drawer.classList.remove('is-busy');
    }).catch(function () {
      drawer.classList.remove('is-busy');
    });
  }

  function init() {
    drawer = document.querySelector('[data-kept-cart]');
    if (!drawer) return;
    list = drawer.querySelector('[data-kept-cart-list]');
    subtotal = drawer.querySelector('[data-kept-cart-subtotal]');
    totalEl = drawer.querySelector('[data-kept-cart-total]');
    emptyEl = drawer.querySelector('[data-kept-cart-empty]');
    footEl = drawer.querySelector('[data-kept-cart-foot]');
    headCount = drawer.querySelector('[data-kept-cart-headcount]');
    countEls = [].slice.call(document.querySelectorAll('[data-kept-cart-count]'));

    ship = drawer.querySelector('[data-kept-ship]');
    if (ship) {
      shipMsg = ship.querySelector('[data-kept-ship-msg]');
      shipFill = ship.querySelector('[data-kept-ship-fill]');
      shipIcon = ship.querySelector('[data-kept-ship-icon]');
    }

    [].forEach.call(document.querySelectorAll('[data-kept-cart-open]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
        fetchCart();
      });
    });

    [].forEach.call(drawer.querySelectorAll('[data-kept-cart-close]'), function (btn) {
      btn.addEventListener('click', close);
    });

    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kept-line]');
      if (!btn) return;
      change(parseInt(btn.getAttribute('data-kept-line'), 10), parseInt(btn.getAttribute('data-kept-qty'), 10));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    /* Intercept add to cart. On any failure the handler steps aside and lets
       the browser submit the form the ordinary way. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.classList.add('is-busy');

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (btn) btn.classList.remove('is-busy');
          open();
          return fetchCart();
        })
        .catch(function () {
          if (btn) btn.classList.remove('is-busy');
          form.submit();
        });
    });

    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
